import { RootState } from '../types'

export const canUpdateUserDataSelector = (state: RootState): RootState['users']['canUpdate'] => state.users.canUpdate
